


(function ($) {
    'use_strict';

    var currentSortValue = null;

    $.support.cors = true;



    /**
     * Apartment selector 2016
     * Author: Fabriken Webbyrå AB
     * Year:2016
     * Useage example:
     * $(document).ready(function () {
     $("#bostadsvaljare").apartmentSelector(
     {
     appID: "4DOADLFD0DOGS9J6", //Project ID
     views: 2, //Views check apartments folder for the count of views.
     debug: false
     }
     );
     });
     * @param {Object} options
     * @returns {undefined}
     */
    $.fn.apartmentSelector = function (options) {

        //__construct
        var self = this;
        self.settings = $.extend({
            jsonUrl: "",
            appID: "",
            views: 0,
            //appUrl: "http://app.local/apibostadsvaljaren/",
            appUrl: "https://api.bostadsvaljaren.se/",
            images: [],
            preloadImages: [],
            doubleClickOnDevice: false,
            navigate: true,
            do_ajax: false,
            new_page: false,
            debug: false,
            width: 1920,
            height: 1080,
            apartmentsInTable: 13,
            theme: 'default'
        }, options);

        if (self.settings.jsonUrl === "" || self.settings.appID === "" || !supportsSVG()) {
            self.remove();
            console.log("Invalid settings for apartmentSelector");
            return false;
        }

        if(self.settings.debug){
            self.settings.appUrl += "dev/";
        }

        self.settings.jsonUrl = self.settings.jsonUrl + self.settings.appID;
        self.dom_id = $(this).attr("id");
        self.activeView = "";
        self.apartments = [];
        self.statusTypes = [['available', 'Till salu'],['no_sale', 'Ej till salu'], ['reserved', 'Reserverad'], ['booked', 'Bokad'], ['sold', 'Såld'], ['sell_later', 'Kommande'], ['display', 'Visningsbostad'], [null, '-']];
        self.svgViews = [];
        self.popup = new app_popup(self);
        self.svg_cont = Snap("#svg");
        self.configUrl = self.settings.appUrl + "gf-apartments/" + self.settings.appID + "/config.json";
        self.imagesUrl = self.settings.appUrl + "gf-apartments/" + self.settings.appID;
        self.hasSvg = supportsSVG() ? true : false;
        self.preloader = new app_preloader(self);
        self.ajax = new app_ajax(self.settings.jsonUrl, 'single-apartment');
        self.dtable = null;
        self.settings.currentView = 3;
        self.isAnimating = false;
        self.firstAnimation = true;

        //Get JSON CONFIG
        $.getJSON(self.configUrl, function (json) {
            self.settings.views = json.views;
            self.settings.width = json.width;
            self.settings.height = json.height;
            self.settings.info = json.info ? json.info : false;
            self.settings.view_names = json.view_names ? json.view_names : false;
            self.settings.animation = json.animation ? json.animation : false;
            self.settings.animationImages = [];

            //Set images & svg depending on views in config!
            for (var i = 1; i < (self.settings.views + 1); i++) {

                var imageO = {
                    view : i,
                    url: self.imagesUrl + "/view" + i + ".jpg",
                    main : true
                } 

                self.settings.images.push(self.imagesUrl + "/view" + i + ".jpg");
                self.settings.preloadImages.push(imageO);
                self.svgViews.push(self.imagesUrl + "/view" + i + ".svg");

                if (self.settings.animation) {

                    // let index = i-1

                    for(var j = 0; j < self.settings.animation[i]; j++){
                        
                        var imageA = {
                            view: i,
                            url: self.imagesUrl + "/animation/view" + i + "/view_" + i + "_" + j + ".jpg",
                            main: false,
                            index: j,
                            elm : null
                        }

                        self.settings.animationImages.push(imageA);
                        self.settings.preloadImages.push(imageA);

                    }
                    

                }

            }

            console.log(self.settings.preloadImages);

            

            $(window).trigger("apartment_construct_completed");

            init();
        });

        /** Construct DONE **/


        /**
         * Init
         * @returns {undefined}
         */
        var init = function () {

            $("body").addClass("apartment_selector").addClass(self.settings.theme);

            self.trace("Building App");
            //Generate CSS
            self.css = new app_css(self.dom_id, self.settings.appUrl);
            //Generate HTML
            self.html(new app_html(self.settings).gethtml());
            //Showing preloader
            self.preloader.show();
            //Setup json data
            self.setUpData();


        };

        /**
         * Go to previous view
         * 
         */
        self.prev = function(){

            var view = self.settings.currentView - 1;

            if(view == 0){
                view = self.settings.views;
            }

            $("body").find("#changeView" + view).trigger("click");

        };

        /**
         * Go to next view
         * 
         */
        self.next = function(){

            var view = self.settings.currentView + 1;

            if(view > self.settings.views){
                view = 1;
            }

            $("body").find("#changeView" + view).trigger("click");

        }

        /**
         * Get images to 
         */
        self.getAllImagesBetween = function(from,to){


            var max = self.settings.views;
            var min = 1;
            var half = max / 2;
            var raw_diff = from > to ? from - to : to - from;
            var mod_diff = raw_diff % max
            var dist = mod_diff > half ? max - mod_diff : mod_diff;

            var direction = ((from + dist) % max) == to || (((from + dist) % max) == 0 && from < to) ? 'forward' : 'backward';

            console.log("DAATA");
            console.log(max,half,raw_diff,mod_diff,dist);
            console.log((from + dist) % max);
            
            var views = [];
            var images = [];

            console.log(direction, from, to);

            if(direction === 'forward'){
                for (var i = from; i <= (from + dist); i++) {
                    if (i > max) {
                        views.push(i - max);
                    } else {
                        views.push(i);
                    }
                }
            }else{
                for (var i = from; i >= from - dist; i--) {
                    if (i < min) {
                        views.push(i + max);
                    } else {
                        views.push(i);
                    }
                }
            }

            for(var i = 0; i < views.length; i++){

                if((i+1 === views.length && direction === 'forward') || (i === 0 && direction === 'backward')){
                    continue;
                }
                
                var allImages = self.settings.animationImages.slice();

                if(direction === 'backward'){
                    allImages = allImages.reverse();
                }

                for(var j = 0; j < allImages.length; j++){ 
 
                    var img = allImages[j];

                    if(img.view == views[i]){
                        images.push(img);
                    }

                }
            }

            return images;

        }

        self.animate = function(view, cb){

            var images = self.getAllImagesBetween(self.settings.currentView, view);

            if(images.length > 0){

                console.log("animate", view, images);

                $("body").find("#animation img").hide();
                var elm = $("body").find("#animation").show();

                var index = 0;
                var lastIndex = 0;

                var ann = setInterval(function(){

                    images[lastIndex].elm.style.display = 'none';
                    images[index].elm.style.display = 'block';

                    if(index === images.length - 1 ){
                        console.log("test");
                        elm.hide();
                        images[index].elm.style.display = 'none';
                        clearInterval(ann);
                        cb();
                    }

                    lastIndex = index;
                    index++;
                    
                
                }, 30);

            }else{
                cb();
            }

            

        }

        self.loop = function(index, images){

        }

        self.displayAnimation = function(){

        }

        /**
         * Adding binds
         * @returns {undefined}
         */
        self.addBinds = function () {
            self.find(".changeView a:not('.external')").bind("click", self.changeView);

            if(self.settings.animation){
                self.find("#animation-play-left").bind("click", self.prev);
                self.find("#animation-play-right").bind("click", self.next);
            }

            self.find("input#showAll").change(self.toggleAllForSale);

            self.find("input#toggleAll").change(self.toggleAll);

            if (self.settings.theme == 'aromalund'){
                self.find("div.character > input").change(self.filterApparments);
            }

            self.filterApparments();
            self.find("#changeView1").trigger('click');
            self.preloader.hide();
            $("html").addClass("svg");

            $("body").find(".apartment_list tr.navigate").bind("click", self.trCLick);
            self.dtable = $('#apartmenttable').DataTable({
                "searching": true,
                "pageLength": self.settings.apartmentsInTable,
                "lengthChange": false,
                "responsive": true,
                pagingType: 'simple_numbers',
                columnDefs: [{
                        orderable: !1,
                        targets: 6
                }, {
                        type: "formatted-num",
                        targets: [4,5]
                    }],
                fnDrawCallback: function (oSettings) {
                    if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                        $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                    } else{
                        $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                    }
                },
                language: {
                    emptyTable: "Tabellen innehåller ingen data",
                    info: "Visar _START_ till _END_ av _TOTAL_ lägenheter",
                    infoEmpty: "Det finns inga lägenheter att visa",
                    infoFiltered: "(filtrerade från totalt _MAX_ rader)",
                    infoPostFix: "",
                    infoThousands: " ",
                    lengthMenu: "Visa _MENU_ rader",
                    loadingRecords: "Laddar...",
                    processing: "Bearbetar...",
                    search: "Sök:",
                    zeroRecords: "Hittade inga matchande lägenheter",
                    paginate: {
                        first: "Första",
                        last: "Sista",
                        next: "Nästa",
                        previous: "Föregående"
                    },
                    aria: {
                        SortAscending: ": aktivera för att sortera kolumnen i stigande ordning",
                        SortDescending: ": aktivera för att sortera kolumnen i fallande ordning"
                    }
                },
                initComplete : function(){
                    $("#apartmenttable").wrap('<div class="apartments-table-responsive"></div>');
                }
            });
            self.trace("All binds loaded!");
        };

        self.trCLick = function (event) {
            event.preventDefault();
            var tr = $(this);
            var id = tr.attr("data-id");
            var link = tr.attr("data-permalink");
            if(link !== ""){
                self.showApparment(id, link);
            }else{
               // console.log("no link..");
            }
        };

        /**
         * Fetching json data
         * @returns {undefined}
         */
        self.setUpData = function () {
            $.getJSON(self.settings.jsonUrl, function (json) {

                if (!$.isEmptyObject(json.apts)) {
                    var jsondata = json.apts;
                    self.trace("-----JSON DATA LOADED------");
                    $.each(jsondata, function (key, value) {

                        value.orig_lghnr = value.std_LghNr;
                        value.std_LghNr = value.std_LghNr.replace('.', '-');
                        value.std_LghNr = value.std_LghNr.replace(/[^a-zA-Z0-9-_]/gi, '');
                        value.std_LghNr = value.std_LghNr.replace(':', '_');

                        if(self.settings.theme === 'gfvyn'){
                            value.std_LghNr = value.std_LghNr.replace('-', '');
                        }


                        //Dev Mode
                        if (value.available === "draft") {
                            return;
                        } else {
                            value.rooms = value.rooms.replace(",", ".");
                            value.roomsDisplay = value.rooms;
                            value.rooms = value.rooms.split("-");
                            value.rooms = missingNumbers(value.rooms);
                            value.size = value.size.replace(",", ".");

                            if(self.settings.theme !== 'viste'){
                                if (typeof value.bi_size != undefined && value.bi_size > 0) {
                                    value.bi_size = value.bi_size.replace(",", ".");
                                } else {
                                    value.bi_size = "";
                                }
                            }

                            
                            
                            self.apartments.push(value);
                        }
                    });

                    self.apartments.sort(SortByLgh);

                    self.trace("-----LOAD IMAGES------");
                    //Load images and setup slider!
                    app_preloadPictures(self.settings.preloadImages, self.setupSliders);
                    self.trace("-----JSON DATA COMPLETED------");

                } else {
                    self.remove();
                    console.log("Could not load data");
                }
            });
        };

        /**
         * Setup app sliders!
         * @returns {undefined}
         */
        self.setupSliders = function () {


            


            // filter actions
            var highestArea = 0;
            var lowestArea = 999;
            var highestPrice = 10;
            var lowestPrice = 99999999999999;
            var lowestRoom = 1;
            var highestRoom = 1;

            for (var i in self.apartments) {
                lowestArea = (Number(self.apartments[i].size) < lowestArea) ? Number(self.apartments[i].size) : lowestArea;
                highestArea = (Number(self.apartments[i].size) > highestArea) ? Number(self.apartments[i].size) : highestArea;

                for (var x in self.apartments[i].rooms) {

                    if (Number(self.apartments[i].rooms[x]) > 0) {
                        lowestRoom = (Number(self.apartments[i].rooms[x]) < lowestRoom) ? Number(self.apartments[i].rooms[x]) : lowestRoom;
                        highestRoom = (Number(self.apartments[i].rooms[x]) > highestRoom) ? Number(self.apartments[i].rooms[x]) : highestRoom;
                    }
                }

                if (parseInt(self.apartments[i].price) > 0) {
                    lowestPrice = (Number(self.apartments[i].price) < lowestPrice) ? Number(self.apartments[i].price) : lowestPrice;
                    highestPrice = (Number(self.apartments[i].price) > highestPrice) ? Number(self.apartments[i].price) : highestPrice;
                }
            }

            if (lowestArea == highestArea) {
                lowestArea = 1;
            }

            if (lowestRoom == highestRoom) {
                lowestRoom = 1;
            }

            if (lowestPrice == highestPrice) {
                lowestPrice = 1;
                if (highestPrice == 1) {
                    highestPrice = 2;
                }
            }

            self.trace("Lowest Area: " + lowestArea);
            self.trace("Highest Area: " + highestArea);
            self.trace("Lowest Price: " + lowestPrice);
            self.trace("Highest Price: " + highestPrice);
            self.trace("Lowest Room: " + lowestRoom);
            self.trace("Highest Room: " + highestRoom);

            self.roomSlider = new app_slider($("#sliderRum"), lowestRoom, highestRoom, $("#roomet"), false, self.filterApparments);
            self.areaSlider = new app_slider($("#sliderBo"), lowestArea, highestArea, $("#boarea"), "m²", self.filterApparments);
            self.priceSlider = new app_slider($("#sliderPrice"), lowestPrice, highestPrice, $("#price"), "kr", self.filterApparments);


            self.addBinds();
        };

        /**
         * Change view
         * @param {Event} event
         */
        self.changeView = function (event) {

            if(self.isAnimating){
                return;
            }

            if(self.firstAnimation){
                $("#view" + self.settings.currentView).show();
                self.firstAnimation = false;
            }

            

            event.stopPropagation();
            event.preventDefault();
            var obj = $(this);
            var svg_cont = Snap("#svg");

            if (!obj.hasClass("active")) {

                self.isAnimating = true;

                var id = obj.attr("id");
                var did = obj.attr("data-id");
                id = id.replace("changeView", "view");

                console.log(id);

                var cid = parseInt(id.replace("view", ""));



                if(self.settings.animation){

                    $("#svg").hide();

                    self.animate(cid, function(){
                        self.settings.currentView = cid;

                        $(".changeView").find("a").removeClass("active");
                        obj.addClass("active");

                        $(".view").hide();
                        $("#" + id).show();

                        $("#svg").show();

                        self.activeView = "#" + id;
                        self.trace("Showing view: #" + id);
                        self.isAnimating = false;
                    });
                }else{
                    
                    self.settings.currentView = cid;

                    $(".changeView").find("a").removeClass("active");
                    obj.addClass("active");

                    $(".view").hide();
                    $("#" + id).show();

                    self.activeView = "#" + id;
                    self.trace("Showing view: #" + id);
                    self.isAnimating = false;

                }

                

                svg_cont.clear();

                var lastClicked = null;
                //Snap.load($app.svgViews[did] + "?rand=" + Math.random() * 100, function (f) {
                //Snap.load($app.svgViews[did], function (f) {
                $(document).load(self.svgViews[did], function (f) {
                    f = Snap.parse(f);
                    var g = f.selectAll('polygon,rect,path');
                    g.forEach(function (app) {
                        var id = app.node.id;
                        var isInfo = false;
                        if (id.indexOf("info_") !== -1) {
                            isInfo = true;
                        }

                        var poly = app;
                        if (self.getAppartment(id) && poly) {
                            poly.attr({'class': self.getAppartment(id).available, 'fill': ''});
                        } else if (isInfo && poly) {
                            poly.attr({'class': 'info', 'fill': ''});
                        } else {
                            poly.attr({'class': 'not_for_sale', 'fill': ''});
                        }

                        poly.hover(function () {
                            if (isInfo) {
                                self.popup.showPopUpInfo(id);
                            } else {
                                self.popup.showPopUp(self.getAppartment(id));
                            }



                        }, function () {
                            self.popup.hidePopUp();
                        }).click(function () {
                       
                            if ((self.getAppartment(id).available == "available" || self.getAppartment(id).available == "reserved" || self.getAppartment(id).available == "sell_later" || self.getAppartment(id).available == "sold") || isInfo) {
                                var ww = $(window).outerWidth();
                                var data = null;
                                var link = false;

                                if (isInfo) {
                                    data = self.popup.get_info(id);


                                    if (data.link !== "") {

                                        if(data.link.indexOf('popup:') !== -1){
                                            var url = data.link.replace('popup:','');
  
                                            $.featherlight(url);
                                            return false;
                                        }

                                        if(data.link.indexOf("view") !== -1){
                                            var view = parseInt(data.link.replace("view","")) > 0 ? parseInt(data.link.replace("view","")) : 1;
                                            $("#changeView"+view).trigger("click");
                                            return false;
                                        }
                                        link = data.link;
                                    }
                                } else {
                                    link = self.getAppartment(id).url;
                                }

                                if (ww > 768 || !self.settings.doubleClickOnDevice) {
                                    self.showApparment(id, link);
                                } else {
                                    if (id == lastClicked) {
                                        self.showApparment(id, link);
                                    }
                                }

                                lastClicked = id;

                            }

                            return false;
                            //location.href = apps[id].Url;
                        });

                    });

                    svg_cont.append(g);

                    self.filterApparments();

                    if ($("input#showAll").is(':checked')) {
                        self.toggleAllForSale();
                    }

                    if ($("input#toggleAll").is(':checked')) {
                        self.toggleAll();
                    }
                });

            }
        };

        self.showApparment = function (id, link) {

            if (self.settings.navigate && link && link !== "") {
                
                if (self.settings.do_ajax) {
                    self.ajax.do_ajax(self.getAppartment(id).GUID);
                } else {
                    if(self.settings.new_page){
                        var win = window.open(link, '_blank');
                        win.focus();
                    }else{
                        window.location = link;
                    }

                }
            }
        };



        // filter apps: with slider and check
        self.filterApparments = function () {

            self.resetSvgElements();

            var allAppartments = [];
            for (var i in self.apartments) {
                allAppartments.push(self.apartments[i]);
            }

            //filter from values from sliders!
            var newAppartments = $.grep(allAppartments, function (s) {

                var result = true;

                if(s.available === "no_sale"){
                    return true;
                }

                if (typeof s.price === undefined || typeof s.size === undefined || typeof s.rooms === undefined)
                    return false;

                if (self.settings.theme === 'aromalund') {
                    
                    var values = Array();
                    
                    self.find(".character input[name='character[]']:checked").each(function(elm){
                        values.push($(this).val());
                    });
                    
                    if(values.indexOf(s.character) == -1){
                        return false;
                    }

                    
                }

                for (var p in s.rooms) {
                    if (Number($("#sliderRum").slider("values", 0)) <= Number(s.rooms[p])
                            && (Number($("#sliderRum").slider("values", 1)) >= Number(s.rooms[p])) && result) {
                        result = false;
                    }
                }

                return ((s.available !== "available" || s.available !== "reserved")
                        && (Number($("#sliderPrice").slider("values", 0)) <= Number(s.price) + 1)
                        && (Number($("#sliderPrice").slider("values", 1)) >= Number(s.price) - 1)
                        && (Number($("#sliderBo").slider("values", 0)) <= Number(s.size) + 1)
                        && (Number($("#sliderBo").slider("values", 1)) >= Number(s.size) - 1)
                        && !result);


            }, true);

            //self.showTable();
            var elementsToHide = [];

            //Highlight new apartments!
            for (var k in newAppartments) {
                //show filtered
                if (newAppartments[k].std_LghNr !== undefined) {
                    self.trace(newAppartments[k].std_LghNr);

                    var sid = newAppartments[k].std_LghNr;

                    if (sid !== undefined) {
                        var svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;
                        //var mySVG = $('#svg #' + sid).length ? $('#svg #' + sid) : null;

                        if (svg_element !== null) {
                            svg_element.addClass('filter');

                        }
                        elementsToHide.push(newAppartments[k].orig_lghnr);

                    }
                }
            }

            self.redraw(elementsToHide);
        };


        self.redraw = function (elementsToHide) {
            if (self.dtable !== null) {

                $.fn.dataTable.ext.search.pop();
                self.dtable.draw();

                $.fn.dataTable.ext.search.push(
                        function (settings, data, dataIndex) {
                            
                            if(elementsToHide.length === 0){
                                return true;
                            }

                            return elementsToHide.indexOf(data[0]) === -1 ? true : false;
                        }
                );

                self.dtable.draw();
            }
        };



        /**
         * Show all apartments that are forsale
         * @todo redo whole function!
         * @returns {undefined}
         */
        self.toggleAll = function () {

            var elementsToHide = [];

            for (var i in self.apartments) {
                //show filtered
                var svg_element = null;
                var sid = null;
                if ($("input#toggleAll").is(':checked')) {
                    console.log("EHEHE");
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect, .showall").addClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (self.apartments[i].available) {
                        if (sid !== undefined) {
                            svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;

                            if (svg_element !== null){
                                svg_element.addClass('hilight');
                            }

                        }
                    } else {
                            elementsToHide.push(sid);
                    }
                } else {
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect, .showall").removeClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (sid !== undefined) {
                        svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;
                        if (svg_element !== null)
                            svg_element.removeClass('hilight');
                    }
                }

            }
            self.redraw(elementsToHide);
        };
        /**
         * Show all apartments that are forsale
         * @todo redo whole function!
         * @returns {undefined}
         */
        self.toggleAllForSale = function () {

            var elementsToHide = [];

            for (var i in self.apartments) {
                //show filtered
                var svg_element = null;
                var sid = null;
                if ($("input#showAll").is(':checked')) {
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect, .toggleall").addClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (self.apartments[i].available == 'available') {
                        if (sid !== undefined) {
                            svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;

                            if (svg_element !== null){
                                svg_element.addClass('hilight');
                            }

                        }
                    } else {
                            elementsToHide.push(sid);
                    }
                } else {
                    $("#controls div.checks, #controls #sliders, #controls #characterSelect, .toggleall").removeClass('disabled');
                    sid = self.apartments[i].std_LghNr;
                    if (sid !== undefined) {
                        svg_element = document.getElementById('' + sid) ? document.getElementById('' + sid) : null;
                        if (svg_element !== null)
                            svg_element.removeClass('hilight');
                    }
                }

            }
            self.redraw(elementsToHide);
        };

        //Get one apartment from the apartments!
        self.getAppartment = function (id) {
            //Get apartment
            var ret = false;
            if (id !== "") {
                $.each(self.apartments, function (key, value) {
                    var obj = value;

                    if (obj.std_LghNr == id) {
                        ret = obj;
                        return false;
                    }
                });
            }

            if (id.indexOf("info_") !== -1) {
                return false;
            }

            if (!ret)
                self.trace("Didnt fin the apartment with ID: " + id);

            return ret;
        };

        /**
         * Reset svg elements
         * @returns {undefined}
         */
        self.resetSvgElements = function () {
            $('#svg polygon,#svg rect,#svg path').each(function () {
                var svg_element = this;
                if (svg_element !== null)
                    svg_element.removeClass('filter'); 
            });
        };

        /**
         * Get nice status
         * @param {string} input
         * @returns {string}
         */
        self.statusTranslate = function (input) {
            for (var i in self.statusTypes) {
                if (input == self.statusTypes[i][0]) {
                    return self.statusTypes[i][1];
                }
            }
        };

        //Trace statements
        self.trace = function (v, condebug) {
            if (self.settings.debug) {
                traceit(v, condebug, self);
            }
        };

    };


    $.extend($.fn.dataTableExt.oSort, {
        "formatted-num-pre": function (a) {
            a = a.replace(/[^\d\S\-\.\/a-zA-Z]/g, '');
            a = parseFloat(a);
            if (!isNaN(a)) {
                return a;
            } else {
                return '';
            }
        },
        "formatted-num-asc": function (a, b) {
            return a - b;
        },
        "formatted-num-desc": function (a, b) {
            return b - a;
        }
    });


    jQuery.fn.dataTableExt.aTypes.unshift(
        function (sData) {
            var deformatted = sData.replace(/[^\d\S\-\.\/a-zA-Z]/g, '');
            var isNumeric = !isNaN(deformatted - parseFloat(deformatted));

            return isNumeric || deformatted === "-" ?
                'formatted-num' :
                null;
        }
    );



})(jQuery, window, document, Snap, app_ajax);
